export class DevCustomerSwitchResult {
    restarting = false;
}
